module.exports = __webpack_public_path__ + "static/media/IconFilter.8a13aba2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/IconFilter.svg
// module id = 942
// module chunks = 0